import { Routes, Route } from "react-router-dom";
import Page404 from "./404";
import "./App.css";
import "./general.css";
import Home from "./components/Home";
import { ref, get, onValue, runTransaction } from "firebase/database"; //いずれ必要なものを追記する！！！
import { db } from "./firebase";
import { Button, ButtonGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

function App() {
  const [en, setEn] = useState(false); // 英語かどうか
  const [cookies, setCookie, removeCookie] = useCookies();
  const [liked, setLiked] = useState(false);
  // いいね済みかどうか取得
  useEffect(() => {
    if (cookies.liked) {
      setLiked(cookies.liked);
    }
  }, []);

  // いいね数
  const [likes, setLikes] = useState(0);
  // いいね数のパス
  const likesRef = ref(db, "likes");
  // いいね数の取得
  useEffect(() => {
    onValue(
      likesRef,
      (snapshot) => {
        setLikes(snapshot.val());
      },
      []
    );
  });
  // いいねする
  const handleLikeButtonClick = () => {
    if (liked) {
      // いいね済みの場合
      runTransaction(
        likesRef,
        (currentLikes) => {
          if (currentLikes === null) {
            return 1;
          } else {
            setCookie("liked", false, { maxAge: 2592000 });
            setLiked(false);
            return currentLikes - 1;
          }
        },
        (error, committed, snapshot) => {
          if (error) {
            console.log("Transaction failed: ", error);
          } else if (!committed) {
            console.log("Transaction not committed");
          } else {
            console.log("Transaction committed: ", snapshot.val());
          }
        }
      );
    } else {
      // いいねしていない場合
      runTransaction(
        likesRef,
        (currentLikes) => {
          if (currentLikes === null) {
            return 1;
          } else {
            setCookie("liked", true, { maxAge: 2592000 });
            setLiked(true);
            return currentLikes + 1;
          }
        },
        (error, committed, snapshot) => {
          if (error) {
            console.log("Transaction failed: ", error);
          } else if (!committed) {
            console.log("Transaction not committed");
          } else {
            console.log("Transaction committed: ", snapshot.val());
          }
        }
      );
    }
  };

  return (
    <div className="App">
      <div className="w-100 p-1 mt-1 text-end">
        <ButtonGroup className="me-2">
          <Button
            variant="outline-light"
            size="sm"
            onClick={() => setEn(false)}
          >
            日本語
          </Button>
          <Button variant="outline-light" size="sm" onClick={() => setEn(true)}>
            English
          </Button>
        </ButtonGroup>
        <Button
          variant={liked ? "warning" : "light"}
          size="sm"
          onClick={handleLikeButtonClick}
        >
          ❤{en ? "Like" : "いいね"}&emsp;{String(likes)}
        </Button>
      </div>
      <Routes>
        <Route path="/" element={<Home en={en} />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      <footer>
        <small>&copy;林クラス, 2024</small>
      </footer>
    </div>
  );
}

export default App;
